import { useState, useEffect, useRef } from "react";
import { ClickAwayListener, Typography } from "@mui/material";
import { Box, Button } from "@material-ui/core";
import themeColorsDesingSystem from "assets/theme/ds-colors";

export default function ButtonSelect({
  buttonText,
  options = [],
  onSelect,
  disabled = false,
  loading = false,
  startIcon,
  buttonWidth = "20vw",
  variant = "contained",
  color = "primary",
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  const handleMenuToggle = () => {
    if (!disabled && !loading) {
      setMenuOpen(!menuOpen);
    }
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  const handleOptionClick = (option) => {
    if (onSelect) {
      onSelect(option.value || option);
    }
    handleMenuClose();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        handleMenuClose();
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [menuOpen]);

  return (
    <ClickAwayListener onClickAway={handleMenuClose}>
      <div style={{ position: "relative" }}>
        <Button
          variant={variant}
          color={color}
          ref={buttonRef}
          onClick={handleMenuToggle}
          disabled={disabled || loading}
          style={{ width: buttonWidth }}
        >
          {startIcon} {buttonText}
        </Button>
        {menuOpen && options.length > 0 && (
          <Box
            ref={menuRef}
            style={{
              position: "absolute",
              top: "100%",
              left: 0,
              marginTop: "4px",
              backgroundColor: "#fff",
              borderRadius: "4px",
              boxShadow:
                "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
              zIndex: 1300,
              minWidth: "100%",
              overflow: "hidden",
            }}
          >
            {options.map((option, index) => (
              <li key={index}>
                <Typography
                  noWrap
                  sx={{
                    fontFamily: "Open Sans,sans-serif",
                    color: themeColorsDesingSystem.text.primary,
                    fontSize: ".875rem",
                    padding: "8px 16px",
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: themeColorsDesingSystem.stone.light,
                    },
                  }}
                  onClick={() => handleOptionClick(option)}
                >
                  {option.label || option.text || option}
                </Typography>
              </li>
            ))}
          </Box>
        )}
      </div>
    </ClickAwayListener>
  );
}
